import React, { useContext, useCallback, useEffect } from 'react'
import { TextInput, TextInputProps } from 'react-native'
import { useField, useFormikContext, FormikContextType } from 'formik'

import { styled, isWeb, composeRefs } from 'tamagui'

import { FormFieldContext } from './shared'
// import { FormTextInputProps } from '../../components/Form/FormTextInput'

import './FormInput.css'

const defaultStyles = {
  className: 'FormInput',

  size: '$true',
  fontFamily: '$body',
  borderWidth: 1,
  outlineWidth: 0,
  color: '$color',

  ...(isWeb
    ? {
        tabIndex: 0,
      }
    : {
        focusable: true,
      }),

  borderColor: '$borderColor',
  backgroundColor: '$background',

  // this fixes a flex bug where it overflows container
  minWidth: 0,

  hoverStyle: {
    borderColor: '$borderColorHover',
  },

  focusStyle: {
    borderColor: '$borderColorFocus',
  },
} as const

const StyledTextInput = styled(
  TextInput,
  {
    name: 'TextInput',
    fontWeight: '400',
    color: '$grey8',
    outlineWidth: 0,
    outlineStyle: 'none',
    borderWidth: 1,
    borderRadius: '$2',
    borderColor: '$grey5',
    placeholderTextColor: '$grey7',

    variants: {
      unstyled: {
        false: defaultStyles,
      },

      size: {
        '...size': (size: any, { tokens, font }: any) => {
          return {
            fontSize: font?.size[size],
            lineHeight: font?.lineHeight[size],
            padding: tokens.space[size === '$true' ? '$2' : size],
          }
        },
      },
    } as const,

    defaultVariants: {
      unstyled: false,
    },
  },
  { isInput: true }
)

export const FormTextInput = StyledTextInput.styleable<{
  onChange?: (value: string) => any
  submitBehaviour?: 'submit-form'
}>(({ onChange, submitBehaviour, ...props }, ref) => {
  const formContext = useFormikContext()
  const formFieldContext = useContext(FormFieldContext)
  const [field, _meta, helpers] = useField(formFieldContext.name)

  const onSubmitEditing = useCallback(() => {
    // Default: submit form on Enter for single-line inputs (standard web behavior)
    // Can be explicitly set via submitBehaviour prop
    if (submitBehaviour === 'submit-form' || !props.multiline) {
      formContext.submitForm()
    }
  }, [formContext, submitBehaviour, props.multiline])

  // useEffect(() => {
  //   const element = formFieldContext.formElementRef
  //   .current as HTMLInputElement | null

  // if (element) {
  //   if (formFieldContext.name) {
  //     element.setAttribute('name', formFieldContext.name)
  //   }

  //   if (props.secureTextEntry && props.passwordRules) {
  //     element.setAttribute('passwordrules', props.passwordRules)
  //   }
  // }
  // }, [formFieldContext.name, props.secureTextEntry, props.passwordRules])

  return (
    <StyledTextInput
      {...props}
      className='FormInput'
      ref={composeRefs(ref, (inputRef: TextInput | null) => {
        if (!inputRef) {
          formFieldContext.formElementRef.current = null
          return
        }

        formFieldContext.formElementRef.current = inputRef
      })}
      value={field.value}
      onSubmitEditing={onSubmitEditing}
      onChangeText={(value) => {
        const newValue =
          props.inputMode === 'numeric' ? value.replace(/\D/g, '') : value

        helpers.setTouched(true)
        helpers.setValue(newValue)

        if (onChange) {
          onChange(newValue)
        }
      }}
    />
  )
})
